import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchProspectusDataUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.fetchProspectusData;
const fetchProspectusFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.fetchProspectusFilings;
const fetchProspectusHistoryUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.fetchProspectusHistory;
const fetchProspectusByClientUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.fetchProspectusByClient;
const seacrhProspectusByKeywordUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.seacrhProspectusByKeyword;
const addOrEditNewProspectusUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.addOrEditNewProspectus;

export const actionType = {
    REQUESTED_PROSPECTUS_DATA: 'REQUESTED_PROSPECTUS_DATA',
    REJECTED_PROSPECTUS_DATA: 'REJECTED_PROSPECTUS_DATA',
    FETCH_PROSPECTUS_DATA: 'FETCH_PROSPECTUS_DATA',
    FETCH_PROSPECTUS_FILINGS: 'FETCH_PROSPECTUS_FILINGS',
    FETCH_PROSPECTUS_HISTORY: 'FETCH_PROSPECTUS_HISTORY',
    FETCH_PROSPECTUS_BY_CLIENT: 'FETCH_PROSPECTUS_BY_CLIENT',
    SEARCH_PROSPECTUS_BY_KEYWORD: 'SEARCH_PROSPECTUS_BY_KEYWORD',
    ADD_NEW_PROSPECTUS: 'ADD_NEW_PROSPECTUS',
    EDIT_PROSPECTUS: 'EDIT_PROSPECTUS',
    UPDATE_PROSPECTUS_SELECTED: 'UPDATE_PROSPECTUS_SELECTED',
    UPDATE_SEARCH_STRING: 'UPDATE_SEARCH_STRING',
    UPDATE_ADD_NEW_PROSPECTUS_PAYLOAD: 'UPDATE_ADD_NEW_PROSPECTUS_PAYLOAD',
    UPDATE_PROSPECTUS_HISTORY_ITEM_SELECTED:
        'UPDATE_PROSPECTUS_HISTORY_ITEM_SELECTED',
    UPDATE_EDIT_PROSPECTUS_PAYLOAD: 'UPDATE_EDIT_PROSPECTUS_PAYLOAD',
    HANDLE_EDIT_PROSPECTUS_VISIBILITY: 'HANDLE_EDIT_PROSPECTUS_VISIBILITY',
    HANDLE_VIEW_PROSPECTUS_VISIBILITY: 'HANDLE_VIEW_PROSPECTUS_VISIBILITY',
    CLEAR_PROSPECTUSES_LIST: 'CLEAR_PROSPECTUSES_LIST'
};

export const fetchProspectusData = prospectusId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpGetRequest(fetchProspectusDataUrl + prospectusId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PROSPECTUS_DATA,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
            });
    };
};

export const fetchProspectusFilings = prospectusId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpGetRequest(fetchProspectusFilingsUrl + prospectusId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PROSPECTUS_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
            });
    };
};

export const fetchProspectusHistory = prospectusId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpGetRequest(fetchProspectusHistoryUrl + prospectusId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PROSPECTUS_HISTORY,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
            });
    };
};

export const fetchProspectusByClient = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpGetRequest(fetchProspectusByClientUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PROSPECTUS_BY_CLIENT,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
            });
    };
};

export const searchProspectusByKeyword = keyword => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpGetRequest(seacrhProspectusByKeywordUrl + keyword)
            .then(response => {
                dispatch({
                    type: actionType.SEARCH_PROSPECTUS_BY_KEYWORD,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
            });
    };
};

export const addNewProspectus = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpPostRequest(addOrEditNewProspectusUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_PROSPECTUS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editProspectus = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PROSPECTUS_DATA
        });

        return generalHttpPutRequest(addOrEditNewProspectusUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_PROSPECTUS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PROSPECTUS_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateProspectusSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_PROSPECTUS_SELECTED,
            payload: selected
        });
    };
};

export const updateSearchString = string => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SEARCH_STRING,
            payload: string
        });
    };
};

export const updateAddNewProspectusPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_PROSPECTUS_PAYLOAD,
            payload: selected
        });
    };
};

export const updateProspectusHistoryItemSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_PROSPECTUS_HISTORY_ITEM_SELECTED,
            payload: selected
        });
    };
};

export const updateEditProspectusPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_PROSPECTUS_PAYLOAD,
            payload: selected
        });
    };
};

export const clearProspectusesList = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_PROSPECTUSES_LIST
        });
    };
};

export const handleEditProspectusVisibility = (visibility) => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_EDIT_PROSPECTUS_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleViewProspectusVisibility = (visibility) => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_VIEW_PROSPECTUS_VISIBILITY,
            visibility: visibility
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/prospectus/actions.js